// src/components/MatchFlow/EventProgressNavBar.jsx
import React from 'react';
import { ReactComponent as TribeLogo } from '../../assets/TribeLogo.svg';

/* ───────── STYLES (match EventPortalNavBar / MixerPortalNavBar) ───────── */
const S = {
  wrapper: {
    position: 'sticky',
    top: 0,
    zIndex: 100,
    background: '#fff',
    fontFamily:
      "'Inter', system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
  },
  navRow: {
    height: 55,
    maxWidth: 1200,
    margin: '0 auto',
    padding: '0 12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    position: 'relative', // for centered logo
  },

  // Left: "End" button (same shape as EventPortalNavBar exit)
  leftBtn: {
    appearance: 'none',
    background: '#fff',
    color: '#374151',
    border: '1px solid #e5e7eb',
    borderRadius: 9999,
    padding: '6px 12px',
    fontSize: '0.8rem',
    fontWeight: 600,
    lineHeight: 1,
    height: 28,
    cursor: 'pointer',
    zIndex: 1,
  },

  // Center: Tribe Logo
  logoCenter: {
    position: 'absolute',
    left: '50%',
    transform: 'translateX(-50%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    pointerEvents: 'none',
  },
  logo: {
    height: 'auto',
    width: 72,
  },

  // Right: Progress pill (copied from UpdateAccountPage vibe)
  rightWrap: {
    zIndex: 1,
    height: 28,
    display: 'flex',
    alignItems: 'center',
  },
  progressPill: {
    background: '#f3f4f6',
    border: '1px solid #e5e7eb',
    color: '#0b0b0b',
    borderRadius: 999,
    padding: '6px 12px',
    fontSize: 12,
    fontWeight: 500, // base
    lineHeight: 1,
  },
  progressStrong: {
    fontWeight: 900,
  },
};

/**
 * EventProgressNavBar
 * - Matches EventPortalNavBar’s structure (sticky, centered logo, left action)
 * - Right side shows the UpdateAccount-style ProgressPill: "Step X/Total"
 *
 * Props:
 *  - leftLabel (string)    default: 'End'
 *  - onLeftClick (fn)      click handler for left button
 *  - currentStep (number)  default: 1
 *  - totalSteps (number)   default: 4
 *  - title (string)        kept for API compatibility (not displayed)
 */
export default function EventProgressNavBar({
  title = 'MatchFlow', // intentionally not displayed to match EventPortalNavBar
  leftLabel = 'End',
  onLeftClick,
  currentStep = 1,
  totalSteps = 4,
}) {
  return (
    <div style={S.wrapper}>
      <div style={S.navRow}>
        {/* Left: End button */}
        <button style={S.leftBtn} onClick={onLeftClick}>
          {leftLabel}
        </button>

        {/* Center: Tribe Logo */}
        <div style={S.logoCenter}>
          <TribeLogo style={S.logo} />
        </div>

        {/* Right: Progress pill (Update Account style) */}
        <div style={S.rightWrap} aria-label="Progress">
          <div style={S.progressPill}>
            Step <span style={S.progressStrong}>{currentStep}</span>/{totalSteps}
          </div>
        </div>
      </div>
    </div>
  );
}
